export default function DseEmiSection({ schemes, emi, setEmi, optional, labelCls }) {
  const set = (k, v) => setEmi((e) => ({ ...e, [k]: v }));
  return (
    <section className="space-y-2" data-testid="dse-emi-section">
      <div className="flex items-center justify-between">
        <span className={labelCls.replace("mb-2", "")}>3 · EMI {optional ? "(optional)" : ""}</span>
        {optional && (
          <button type="button" onClick={() => set("enabled", !emi.enabled)} data-testid="dse-emi-toggle"
            className={`px-3 py-1 text-xs font-mono uppercase tracking-wider border transition-colors ${emi.enabled ? "bg-ink text-white border-ink" : "border-canvas-line text-ink-muted"}`}>
            {emi.enabled ? "EMI on" : "Add EMI"}
          </button>
        )}
      </div>
      {emi.enabled && (
        <>
          <select value={emi.scheme_id} onChange={(e) => set("scheme_id", e.target.value)} data-testid="dse-scheme"
            className="w-full border border-canvas-line bg-white px-3 py-3 text-sm focus:outline-none focus:border-ink">
            <option value="">— pick finance scheme —</option>
            {schemes.map((s) => (
              <option key={s.id} value={s.id}>
                {s.product_id} · {s.tenure}m · {Math.round((s.down_payment_pct || 0) * 100)}% DP
              </option>
            ))}
          </select>
          <input value={emi.down_payment} inputMode="numeric"
            onChange={(e) => set("down_payment", e.target.value.replace(/[^\d.]/g, ""))}
            placeholder="Down payment ₹ (blank = scheme default)" data-testid="dse-down-payment"
            className="w-full border border-canvas-line bg-white px-3 py-3 font-mono text-sm focus:outline-none focus:border-ink" />
        </>
      )}
    </section>
  );
}
